import { UserDto } from "./usersApi";

const NEW_USER_COLORS = [
  '#cf1322',
  '#d46b08',
  '#d4b106',
  '#389e0d',
  '#08979c',
  '#0958d9',
  '#531dab',
  '#c41d7f',
]

const pickRandomNewUserColor = () =>
  NEW_USER_COLORS[Math.floor(Math.random() * NEW_USER_COLORS.length)]

export const emptyUserState = (): UserDto => ({
  avatarDataBase64: '',
  roles: [],
  isActive: true,
  email: '',
  prefix: '',
  color: pickRandomNewUserColor(),
  displayName: '',
  isSuperUser: false,
  isFreeUser: false,
  avatar: '',
  id: '',
  url: '',
  sequence: 0
})

export type UserFormAction =
  | { type: 'SET_AVATAR'; payload: string }
  | { type: 'SET_ROLES'; payload: string[] }
  | { type: 'SET_FIELD'; fieldName: keyof UserDto; payload: any }
  | { type: 'RESET_FORM'; payload: UserDto }

export function userFormReducer(state: UserDto, action: UserFormAction): UserDto {
  switch (action.type) {
    case 'SET_AVATAR':
      return { ...state, avatarDataBase64: action.payload }
    case 'SET_ROLES':
      return { ...state, roles: action.payload }
    case 'SET_FIELD':
      return { ...state, [action.fieldName]: action.payload }
    case 'RESET_FORM':
      return { ...action.payload }
    default:
      return state
  }
}
